import checkService from "../../services/checkService";
import leadService from "../../services/leadService";

const getDefaultState = () => {
  return {
    competitorElecProduct: null,
    competitorGasProduct: null,
    megaElecProduct: null,
    megaGasProduct: null,
    elecProducts: null,
    gasProducts: null,
    myElecProduct: null,
    myGasProduct: null,
    peers: null,
    economyText: null,
    savingsElec: null,
    savingsGas: null
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setCompetitorElecProduct(state, value) {
      state.competitorElecProduct = value;
    },
    setCompetitorGasProduct(state, value) {
      state.competitorGasProduct = value;
    },
    setMegaElecProduct(state, value) {
      state.megaElecProduct = value;
    },
    setMegaGasProduct(state, value) {
      state.megaGasProduct = value;
    },
    setElecProducts(state, value) {
      state.elecProducts = value;
    },
    setGasProducts(state, value) {
      state.gasProducts = value;
    },
    setMyElecProduct(state, value) {
      state.myElecProduct = value;
    },
    setMyGasProduct(state, value) {
      state.myGasProduct = value;
    },
    setEconomyText(state, value) {
      state.economyText = value;
    },
    setPeers(state, value) {
      state.peers = value;
    },
    setSavingsElec(state, value) {
      state.savingsElec = value;
    },
    setSavingsGas(state, value) {
      state.savingsGas = value;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    async getComparison(context) {
      // await context.dispatch("resetComparison");
      let comparisonData = await context.dispatch("getComparisonData");
      try {
        let response = await checkService.getComparison(comparisonData);

        if (response.electricity) {
          let defaultCompElecProduct = response.electricity.competitor.find(
            product => product.byDefault === true
          );

          if (!context.state.myElecProduct) {
            let myElecProduct = Object.assign({}, defaultCompElecProduct);
            myElecProduct.id = "myElec";
            myElecProduct.peer = "myGas";
            myElecProduct.labelFr = "J'encode mes prix (HTVA)";
            myElecProduct.labelNl = "Ik vul m'n prijzen in (ex. BTW)";
            response.electricity.competitor.push(myElecProduct);
          } else {
            response.electricity.competitor.push(context.state.myElecProduct);
          }

          context.commit("setElecProducts", response.electricity);
          if (
            context.state.competitorElecProduct &&
            response.electricity.competitor.find(
              product => product.id === context.state.competitorElecProduct.id
            )
          ) {
            context.commit(
              "setCompetitorElecProduct",
              response.electricity.competitor.find(
                product => product.id === context.state.competitorElecProduct.id
              )
            );
          } else {
            context.commit("setCompetitorElecProduct", defaultCompElecProduct);
          }
        }

        if (response.gas) {
          let defaultCompGasProduct = response.gas.competitor.find(
            product => product.byDefault === true
          );
          if (!context.state.myGasProduct) {
            let myGasProduct = Object.assign({}, defaultCompGasProduct);
            myGasProduct.id = "myGas";
            myGasProduct.peer = "myElec";
            myGasProduct.labelFr = "J'encode mes prix (HTVA)";
            myGasProduct.labelNl = "Ik vul m'n prijzen in (ex. BTW)";
            response.gas.competitor.push(myGasProduct);
          } else {
            response.gas.competitor.push(context.state.myGasProduct);
          }
          context.commit("setGasProducts", response.gas);

          if (
            context.state.competitorGasProduct &&
            response.gas.competitor.find(
              product => product.id === context.state.competitorGasProduct.id
            )
          ) {
            context.commit(
              "setCompetitorGasProduct",
              response.gas.competitor.find(
                product => product.id === context.state.competitorGasProduct.id
              )
            );
          } else {
            context.commit("setCompetitorGasProduct", defaultCompGasProduct);
          }
        }

        context.commit("setPeers", response.peers);
        context.dispatch("setDefaultMegaProduct");
      } catch (error) {
        throw error;
      }
    },

    getComparisonData(context) {
      let consumptionsArray = context.rootState.consumption.consumptions.filter(
        consumption =>
          context.rootState.consumption.meterType.includes(
            consumption.meterType
          ) && consumption.meterType !== "gas"
      );

      let consumptions = consumptionsArray.reduce((acc, it) => {
        if (it.meterType !== "mono") {
          acc[it.meterType] = it.value;
        } else {
          acc["day"] = it.value;
        }
        return acc;
      }, {});

      let comparisonData = {
        customerType: context.rootState.contact.isPro ? "pro" : "resi",
        promo: true,
        eco: true,
        postalCode: context.rootState.calculation.zipCode,
        town: context.rootState.calculation.city
      };

      if (context.rootGetters["energy/hasElec"]) {
        comparisonData.electricity = {
          provider: context.rootState.calculation.providerElec,
          powerPv: context.rootState.consumption.hasSolarPanels
            ? context.rootState.consumption.solarPanelsPower
            : null,
          consumption: consumptions,
          products: context.rootState.podium.simulationProducts.electricity
        };
      }

      if (context.rootGetters["energy/hasGas"]) {
        let consumptionGas = context.rootState.consumption.consumptions.find(
          consumption => consumption.meterType === "gas"
        ).value;

        comparisonData.gas = {
          provider: context.rootState.calculation.providerGas,
          consumption: consumptionGas,
          products: context.rootState.podium.simulationProducts.gas
        };
      }

      return comparisonData;
    },

    setCompetitorProduct(context, { energy: energy, product: product }) {
      if (energy === "elec") {
        context.commit("setCompetitorElecProduct", product);
      } else {
        context.commit("setCompetitorGasProduct", product);
      }

      context.dispatch("setDefaultMegaProduct");
    },

    setDefaultMegaProduct(context) {
      if (context.rootGetters["energy/hasElec"] && context.state.elecProducts) {
        let megaElecProducts = context.state.elecProducts.mega;
        let megaElecProduct = null;

        let peer = context.state.peers.find(
          peer =>
            peer.competitorProduct === context.state.competitorElecProduct.id
        );

        if (peer !== undefined) {
          megaElecProduct = megaElecProducts.find(
            product => product.id === peer.megaProduct
          );
        } else {
          if (context.state.megaElecProduct)
            megaElecProduct = context.state.megaElecProduct;
          else {
            megaElecProduct = megaElecProducts.reduce(
              (min, p) =>
                p.total.priceEuroVAT < min.total.priceEuroVAT ? p : min,
              megaElecProducts[0]
            );
          }
        }

        context.commit("setMegaElecProduct", megaElecProduct);
      }

      if (context.rootGetters["energy/hasGas"] && context.state.gasProducts) {
        let megaGasProducts = context.state.gasProducts.mega;
        let megaGasProduct = null;

        let peer = context.state.peers.find(
          peer =>
            peer.competitorProduct === context.state.competitorGasProduct.id
        );

        if (peer !== undefined) {
          megaGasProduct = context.state.gasProducts.mega.find(
            product => product.id === peer.megaProduct
          );
        } else {
          if (context.state.megaGasProduct)
            megaGasProduct = context.state.megaGasProduct;
          else {
            megaGasProduct = megaGasProducts.reduce(
              (min, p) =>
                p.total.priceEuroVAT < min.total.priceEuroVAT ? p : min,
              megaGasProducts[0]
            );
          }
        }

        context.commit("setMegaGasProduct", megaGasProduct);
      }
    },

    resetComparison(context) {
      context.commit("setElecProducts", null);
      context.commit("setGasProducts", null);
      context.commit("setPeers", null);
      context.commit("setMegaElecProduct", null);
      context.commit("setMegaGasProduct", null);
    },

    async save(context, event) {
      let data = {
        uuid: context.rootState.common.uuid
      };

      try {
        let comparison = {};
        comparison["electricity"] = context.state.elecProducts;
        comparison["gas"] = context.state.gasProducts;
        data["comparisonResult"] = comparison;

        data["savingsElec"] = context.state.savingsElec;
        data["savingsGas"] = context.state.savingsGas;

        if (context.state.megaElecProduct) {
          data["megaProductElec"] = context.state.megaElecProduct;
        }

        if (context.state.megaGasProduct) {
          data["megaProductGas"] = context.state.megaGasProduct;
        }

        if (context.state.competitorElecProduct) {
          data["competitorProductElec"] = context.state.competitorElecProduct;
        }

        if (context.state.competitorGasProduct) {
          data["competitorProductGas"] = context.state.competitorGasProduct;
        }

        await leadService.save(data);
      } catch (error) {
        throw error;
      }
    }
  },
  getters: {
    productName: state => product => {
      return `${product.range} - ${product.contractType} - ${product.duration}`;
    },
    findPeer: state => product => {
      let energyChanged = product.energyType;
      let peerProduct = null;

      if (energyChanged === "gas") {
        if (state.elecProducts) {
          let allElecProducts = state.elecProducts.mega.concat(
            state.elecProducts.competitor
          );
          peerProduct = allElecProducts.find(
            peerProduct => peerProduct.id === product.peer
          );
        }
      } else {
        if (state.gasProducts) {
          let allGasProducts = state.gasProducts.mega.concat(
            state.gasProducts.competitor
          );
          peerProduct = allGasProducts.find(peerProduct => {
            return peerProduct.id === product.peer;
          });
        }
      }

      return peerProduct;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/comparison.js